import DocumentIcon from '@diligentcorp/atlas-react-icons/dist/esm/lens/Document.js';
import { LensTheme } from '@diligentcorp/atlas-theme-mui-lens';
import { Box, Stack, Typography, useTheme } from '@mui/material';
import React, { useState } from 'react';
import { RetentionRuleType } from 'src/graphql';
import { RuleDrawer } from '../../organisms';
import { RuleCardVariant, RuleDrawerVariant } from '../../utils/types';
import { DeleteRuleDialog } from '../DeleteRuleDialog';
import { LensButton } from '../LensButton';

interface RuleCardContentProps {
  rule: RetentionRuleType;
  setRuleDrawer: (ruleDrawer: RuleDrawer) => void;
  padding?: string;
  title: string;
  subtitle: string;
  variant: RuleCardVariant;
  country?: string;
}

export const RuleCardContent: React.FC<RuleCardContentProps> = ({
  rule,
  padding = '0',
  title,
  subtitle,
  setRuleDrawer,
  variant,
  country,
}) => {
  const { tokens } = useTheme<LensTheme>();
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

  return (
    <>
      <Box
        key={rule.id}
        sx={{
          padding,
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: tokens.core.spacing['1_5'].value,
          width: '100%',
          boxShadow: 'none',
        }}
      >
        <Stack
          direction="row"
          sx={{
            alignItems: 'center',
            gap: tokens.core.spacing['1_5'].value,
          }}
        >
          <DocumentIcon size="lg" />
          <Stack
            direction="column"
            sx={{
              gap: tokens.core.spacing['0_5'].value,
            }}
          >
            <Typography
              variant="body1"
              sx={{
                fontWeight: tokens.semantic.fontWeight.emphasis.value,
              }}
            >
              {title}
            </Typography>
            <Typography
              variant="caption"
              sx={{
                color: tokens.semantic.color.type.muted.value,
              }}
            >
              {subtitle}
            </Typography>
          </Stack>
        </Stack>
        <Stack direction="row" spacing={1}>
          <LensButton
            variant="secondary"
            buttonSize="small"
            onClick={() => {
              setRuleDrawer({
                isOpen: true,
                variant:
                  variant === RuleCardVariant.RETENTION
                    ? RuleDrawerVariant.EDIT
                    : RuleDrawerVariant.EDITFALLBACK,
                rule,
                country,
              });
            }}
          >
            Edit rule
          </LensButton>
          <LensButton
            variant="danger"
            buttonSize="small"
            onClick={() => setDeleteDialogOpen(true)}
          >
            Delete Rule
          </LensButton>
        </Stack>
      </Box>
      <DeleteRuleDialog
        ruleId={rule.id}
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
      />
    </>
  );
};
